"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKIN_HEIGHT_MAP = void 0;
exports.SKIN_HEIGHT_MAP = {
    EPlayerFramedPlay: {
        mobile: 82,
        desktop: 68,
    },
    EPlayerLargePlay: {
        mobile: 75,
        desktop: 75,
    },
    EPlayerRoundPlay: {
        mobile: 65,
        desktop: 52,
    },
    SingleAudioPlayerSkin: {
        mobile: 76,
        desktop: 60,
    },
};
//# sourceMappingURL=constants.js.map